import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false)),
      class: "cursor-help relative z-10"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.showTooltip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["absolute z-50 opacity-100", _ctx.tooltipClasses]),
              style: {"z-index":"9999"}
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg transform transition-transform duration-200 opacity-100", _ctx.showTooltip ? 'scale-100' : 'scale-95']),
                style: {"width":"300px","opacity":"1 !important"}
              }, [
                _createElementVNode("div", { innerHTML: _ctx.content }, null, 8, _hoisted_2)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["absolute w-2 h-2 bg-gray-900 transform rotate-45", _ctx.arrowClasses])
              }, null, 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}